import { IMenuItem } from '../Interfaces/IMenuItem'
import { faClockRotateLeft, faCodeMerge, faDashboard, faHouseChimney, faPlus, faUserGear } from '@fortawesome/free-solid-svg-icons'
import Customers from '../Customers/Customers'
import AddCustomer from '../Customers/AddCustomer'
import Landing from '../Landing/Landing'
import AuditLog from '../Audit/AuditLog'
import UserAccounts from '../Users/UserAccounts'
import { AppPermission } from '../Permissions/PermissionDefinitions'
import Duplix from '../Duplicates/Duplix'

export const MenuItems: IMenuItem[] = [
  {
    title: 'Etusivu',
    description: 'Etusivu',
    id: 'home',
    icon: faDashboard,
    permissions: [AppPermission.ADDRESS_VIEW, AppPermission.AUDIT_VIEW, AppPermission.USER_ACCOUNT_MANAGE],
    component: Landing,
    hidden: false
  },
  {
    title: 'Kohteet',
    description: 'Kohdehallinta',
    id: 'customers',
    icon: faHouseChimney,
    component: Customers,
    permissions: [AppPermission.ADDRESS_VIEW],
    hidden: false
  },
  {
    title: 'Uusi kohde',
    description: 'Uusi kohde',
    id: 'add-customer',
    icon: faPlus,
    permissions: [AppPermission.ADDRESS_CREATE],
    component: AddCustomer,
    hidden: false
  },
  {
    title: 'Tapahtumat',
    description: 'Tapahtumat',
    id: 'audit-log',
    icon: faClockRotateLeft,
    permissions: [AppPermission.AUDIT_VIEW],
    component: AuditLog,
    hidden: true
  },
  {
    title: 'Duplix',
    description: 'Ohjattu duplikaattien käsittely',
    id: 'duplix',
    icon: faCodeMerge,
    permissions: [AppPermission.ADDRESS_DUPLICATE_MANAGE],
    component: Duplix,
    hidden: true
  },
  {
    title: 'Käyttäjätilit',
    description: 'Käyttäjätilit',
    id: 'user-accounts',
    icon: faUserGear,
    permissions: [AppPermission.USER_ACCOUNT_MANAGE],
    component: UserAccounts,
    hidden: true
  }
]
